// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ntable[data-v-27149284]{\r\n\twidth:100%;\r\n\tborder-spacing: 0;\n}\nth[data-v-27149284]{\r\n\twidth: calc(100%/8);\r\n\tbackground-color:lightgray;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
